import * as THREE from "three";
import Experience from "./Experience.js";

export default class Interactions {
  constructor() {
    this.experience = new Experience();
    this.currentSelectedObject = [];
    this.raycaster = this.experience.raycaster;

    this.addInteractionControl();
    this.setInteractionEventListener();
  }

  addInteractionControl() {
    this.btnInteraction = document.createElement(`button`);
    this.btnInteraction.id = `btn_interaction`;
    this.btnInteraction.className = `btn_interaction`;
    this.btnInteraction.innerText = "Interact";
    document.body.appendChild(this.btnInteraction);
  }

  setInteractionEventListener() {
    this.btnInteraction.addEventListener("click", () => {
      this.processInteraction();
    });
    document.addEventListener("keydown", () => {
      this.processInteraction();
    });
  }

  processInteraction() {
    if (this.raycaster.intersects.length) {

      if (this.currentSelectedObject.name === "lamp") {
        if (this.experience.world.lamp.lampLight.distance > 0.01) {
          this.experience.world.lamp.lampLight.distance = 0.01;
        } else {
          this.experience.world.lamp.lampLight.distance = 2;
        }
      }

      if (
        this.currentSelectedObject.name === "coffee" ||
        this.currentSelectedObject.name === "mug"
      ) {
        this.experience.world.mug.coffee.empty = true
      }

      if (this.currentSelectedObject.name === "lightswitch") {
          this.experience.world.environment.toggleAmbientLight();
      }
    }
  }

  update() {
    this.currentSelectedObject =
      this.experience.raycaster.currentSelectedObject;
    this.raycaster.intersects.length
      ? this.btnInteraction.classList.add("active")
      : this.btnInteraction.classList.remove("active");
  }
}
